import { IAccount } from '@modeso/types__aumico-lib-annualreport-be';

export interface IIncomeAccountSelectionDialogData {
    incomeAccounts: IAccount[];
    incomeCurrentYearFromDate: string | null;
    incomeCurrentYearToDate: string | null;
    incomePreviousYearFromDate: string | null;
    incomePreviousYearToDate: string | null;
}
